var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redeemWrapper"},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate","md-diameter":50,"md-stroke":3}}),_c('div',{staticClass:"redeeming"},[_vm._v("Redeeming...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }